<template>
  <div class="information">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="Paypal争议费" name="first">
        <DisputeFee v-if="activeName=='first'"></DisputeFee>
      </el-tab-pane>
      <el-tab-pane label="Paypal退款" name="second">
        <Reimburse v-if="activeName=='second'"></Reimburse>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DisputeFee from './DisputeFee/DisputeFee'
import Reimburse from './Reimburse/Reimburse'
export default {
  name: 'PayPalFeeImport',
  components: {
    DisputeFee,
    Reimburse
  },
  data() {
    return {
      activeName: 'first'
    }
  }
}
</script>
